// extracted by mini-css-extract-plugin
export default {"homeSection":"HomePage_homeSection__IdVBR"};